






















































import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';
import { Appointment } from '@/types';
import { formatDateFormat, formatInTimeZone, getPhaseCompletionStatus, getPhaseIcon } from '@/util';
import { ApptStatusMessage, EventType, JobStatus, Routes } from '@/constants';
import { getAppointmentStatus } from '../services/service';
import { bus } from '@/main';
import { jobOwnershipStatus } from '@/views/dashboard/services/service';

export default Vue.extend({
  name: 'AppointmentListItem',
  data () {
    return {
      ApptStatusMessage,
      Routes
    }
  },
  props: {
    appointment: {
      type: Object as PropType<Appointment>
    }
  },
  computed: {
    postClose (): boolean {
      return [JobStatus.POST_CLOSE].includes(jobOwnershipStatus());
    },
    ...mapGetters(['mileStones', 'isLoggedInAsAdmin']),
    appointmentStatus (): string {
      if (this.postClose && this.appointment.stage.phase.phase.toLowerCase() !== 'own') {
        return ApptStatusMessage.Completed;
      }
      return getAppointmentStatus(this.appointment);
    },
    formattedDate (): string {
      const initial = this.appointment.appointmentDate?.split(/\//);
      return [initial[1], initial[0], initial[2]].join('/');
    }
  },
  methods: {
    getStatus (value: string): string {
      const data = this.mileStones[value];
      const status = data?.status?.stage;
      return getPhaseCompletionStatus(status);
    },
    getPhaseIcon (phase: string) {
      return getPhaseIcon(phase);
    },
    formatTime (time: Date | string) {
      return formatInTimeZone(time, 'h:mm a');
    },
    formatAppointmentDate (date: string) {
      const initial = date?.split(/\//);
      const nDate = [initial[2], initial[1], initial[0]].join('-');
      const dateStr = nDate + 'T00:00:00';
      const option: Intl.DateTimeFormatOptions = {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      };
      return new Intl.DateTimeFormat('en-US', option).format(new Date(dateStr));
    },
    formatDate (date: string | Date) {
      return formatDateFormat(date, 'ddd, MMM DD')
    },
    scheduleAppointment (appointment: Appointment) {
      if (!this.isLoggedInAsAdmin) {
        this.$router.push({
          name: Routes.SCHEDULE_APPOINTMENT,
          params: {
            appointmentTypeId: appointment.appointmentType.appointmentTypeId
          },
          query: {
            appointmentId: appointment.appointmentId,
            prev: Routes.APPOINTMENTS
          }
        });
      } else {
        bus.$emit(EventType.VIEW_VERSION);
      }
    },
    showAppointmentDetails () {
      bus.$emit(EventType.APPOINTMENT_DETAILS, this.appointment.appointmentId, Routes.APPOINTMENTS);
    }
  }
});
